import { ConfigWithCallbacks } from '@root/types/config'
import React, { Suspense } from 'react'

import { Spinner } from '@components/Spinner'
import { createRoot, Root } from 'react-dom/client'

const FAVanilla = React.lazy(() => import('./FAVanilla'))

//FACE SCAN VANILLA UI
export default class FAVanillaWidget {
  config?: ConfigWithCallbacks
  private root: Root | null = null

  constructor(config: ConfigWithCallbacks) {
    this.config = config
  }

  async render() {
    if (!this.config) {
      throw new Error('Config is not defined')
    }

    const { selector } = this.config
    const container = document.querySelector(selector)
    this.root = container ? createRoot(container) : null

    if (!container || !this.root) {
      throw new Error(
        `You requested Frame Advisor to render inside the element with the selector ${selector}, but there is no such element in the document. Check the "selector" parameter in Frame Advisor initialization or your DOM.`,
      )
    }

    this.root.render(
      <Suspense fallback={<Spinner />}>
        <FAVanilla config={this.config} />
      </Suspense>,
    )
  }
}
